import { ReactNode } from "react";

import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { media } from "@atlaskit/primitives";

import { Adg4TextUnderline } from "@/components/adg4/text-underline/src";
import { Picture } from "@/components/wpl/image/src";
import { Button } from "@/libraries/design/components/button/src/button";
import { useLocalizedHref } from "@/libraries/web-framework";
import { TypographyStyles } from "@/libraries/wpl/foundations/src";
import { Row } from "@/libraries/wpl/foundations/src";

export const HeroTWCHeader = () => {
    const signupLink = useLocalizedHref(
        "/try/cloud/signup?bundle=teamwork-collection&edition=premium"
    );
    return (
        <TypographyStyles>
            <Row>
                <div css={containerStyles}>
                    <Picture
                        image={{
                            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/45u0b4ppp52x032pe78p58n2335x8235.svg",
                            alt: "teamwork collection logo",
                            width: 207,
                            height: 50
                        }}
                    />
                    <h1 className="superhero-contrast" css={heroTitleStyles}>
                        <FormattedMessage
                            id="HomePageTemplateV2.jiraHero"
                            defaultMessage="The platform for{br}<teamwork>AI-powered</teamwork> teamwork"
                            values={{
                                // eslint-disable-next-line react/no-unstable-nested-components
                                teamwork: (str: ReactNode) => (
                                    <Adg4TextUnderline
                                        underlineInset="-13.5%"
                                        underline={
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="100%"
                                                height="8"
                                                viewBox="0 0 329 8"
                                                fill="none"
                                            >
                                                <path
                                                    d="M6.46577 0.23741C-1.85858 0.389397 -2.31998 3.55263 6.1005 4.07508C18.0199 4.80652 30.4776 5.20549 46.5303 5.43347C64.717 5.49046 69.2733 4.88251 81.5964 5.08199C102.417 5.30047 137.483 6.51637 145.923 6.82035C147.172 6.86784 148.422 6.88684 149.671 6.87734C158.63 6.84884 197.964 6.72535 231.781 7.3238C255.658 7.59928 270.442 7.77976 278.17 7.86526C296.357 8.11223 310.064 7.97924 323.252 7.78926C329.923 7.78926 331.634 5.10099 323.81 4.36955C310.353 3.33414 296.741 2.83069 278.459 2.52672C271.365 2.43173 256.619 1.4723 235.76 1.11133C232.357 1.05434 228.955 1.06384 225.59 1.14933C196.445 1.87127 158.707 1.22533 158.707 1.22533C158.707 1.22533 102.378 0.664871 78.5973 0.427391C60.699 0.237407 52.0863 0.151916 46.7994 0.0949209C30.7852 -0.0855637 18.3083 0.0094276 6.46577 0.227909V0.23741Z"
                                                    fill="#FCA700"
                                                />
                                            </svg>
                                        }
                                    >
                                        {str}
                                    </Adg4TextUnderline>
                                ),
                                br: <br />
                            }}
                        />
                    </h1>
                    <p className="body-lg" css={subtitleStyles}>
                        Unlock the future of teamwork with software solutions
                        that break down silos, boost productivity, and put Rovo
                        AI to work
                    </p>
                    <Button
                        css={heroGetStartedStyles}
                        variant="primary"
                        color="blue"
                        href={signupLink}
                        dataEventProps={{
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-event-container": "heroSection",
                            "data-product-key": "home",
                            "data-label-english": "Get started"
                        }}
                    >
                        {" "}
                        Get started
                    </Button>
                </div>
            </Row>
        </TypographyStyles>
    );
};

const containerStyles = css({
    display: "grid",
    justifyItems: "center",
    paddingBlockStart: "40px"
});

const heroTitleStyles = css({
    marginBlockStart: "19px",
    marginBlockEnd: 0,
    textAlign: "center"
});

const heroGetStartedStyles = css({
    marginBlockEnd: "40px",
    [media.below.sm]: {
        marginBlockEnd: "45px"
    }
});

const subtitleStyles = css({
    maxWidth: "578px",
    textAlign: "center"
});
